import { CLIENT_PROGRAM_LEVELS } from '@src/graphql/queries/clientProgramLevel';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useClientProgramLevels = ({ clientId, searchText, countryCode, isActive, type, initialPageSize = 100, }) => {
    const { page, setPage, pageSize, setPageSize, total, items: clientProgramLevels, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        spec: { clientId, name: searchText, countryCode, isActive, type },
        fetchQuery: CLIENT_PROGRAM_LEVELS,
        dataProp: 'clientProgramLevels',
        initialPageSize,
    });
    return {
        clientProgramLevels,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
